import {mutationTypes} from '@/core/constants'

export default {

    [mutationTypes.GALERIA_PACIENTE.SET_FILTROS_BUSCA_TODAS_MIDIAS](state, filtros) {
        state.resultadoBuscaTodasMidias.filtros = filtros
    },

    [mutationTypes.GALERIA_PACIENTE.SET_PAGINACAO_BUSCA_TODAS_MIDIAS](state, paginacao) {
        state.resultadoBuscaTodasMidias.paginacao = paginacao
    },

    [mutationTypes.GALERIA_PACIENTE.RESETA_PAGE](state) {
        state.resultadoBuscaTodasMidias.paginacao.page = 1
    },

}